export class TechTableInfoModel {
  title: string;
  items: TechTableInfoItemModel[] = [];
  //URL to retrieve TReport. Optional.
  url?: string;
  isFavourite: boolean;
  code?: string;

  constructor(
    title: string,
    items: TechTableInfoItemModel[],
    url?: string,
    isFavourite?: boolean,
    code?: string
  ) {
    this.title = title;
    this.items = items;
    if (url != undefined) this.url = url;
    if (isFavourite != undefined) this.isFavourite = isFavourite;
    if (code != undefined) this.code = code;
  }
}

export class TechTableInfoItemModel {
  label: string;
  value: string;
  isInnerHtml: boolean;

  constructor(label: string, value: string, isInnerHtml: boolean = false) {
    this.label = label;
    this.value = value;
    this.isInnerHtml = isInnerHtml;
  }
}
